import React from 'react';

import Header from 'components/organisms/Header';
import Footer from 'components/organisms/Footer';
import Alert from 'components/molecules/Alert';
import Confirm from 'components/molecules/Confirm';

const App = ({ children }) => (
	<div>
		<Header />
		{children}
		<Footer />
		<Alert />
		<Confirm />
	</div>
);

export default App;
